import { COMMUNITY_DASHBOARD_FILTER_TYPE } from './constants';

export default (innerAppliedFilters, appliedFilters) => {
  let filterDifferences = false;

  if (appliedFilters.length === 0 && innerAppliedFilters.length === 0) {
    return false;
  }

  for (let i = 0; i < innerAppliedFilters.length; i += 1) {
    const iAF = innerAppliedFilters[i];

    if (iAF.type === COMMUNITY_DASHBOARD_FILTER_TYPE.PROFILE_TAG) {
      if (!iAF.tags.category || iAF.tags.category === '') {
        filterDifferences = true;
        break;
      }

      if (!iAF.tags.tagName || iAF.tags.tagName === '') {
        filterDifferences = true;
        break;
      }

      if (!iAF.tags.tagValue || iAF.tags.tagValue === '') {
        filterDifferences = true;
        break;
      }
    }

    if (iAF.type === COMMUNITY_DASHBOARD_FILTER_TYPE.USER_PROPERTY) {
      if (
        !iAF.userProperties.propertyName ||
        iAF.userProperties.propertyName === ''
      ) {
        filterDifferences = true;
        break;
      }

      if (
        !iAF.userProperties.propertyValue ||
        iAF.userProperties.propertyValue === ''
      ) {
        filterDifferences = true;
        break;
      }
    }
  }

  return !filterDifferences;
};
